import {
    InfectionEntryViewSetInfectionInformationSerializer,
    InfectionEntryViewSetSerializer,
    InfectionInformationSerializer,
    LocationWithUnitSerializer,
} from '../@core/api.service';
import {Patient} from './patient';
import {PatientForVisit} from './patient-for-visit';
import {comparePeriod} from '../@theme/helpers';
import {getId} from '../utils/type.utils';
import {CheckPatientCache} from '../@core/utils/check-patient-cache';
import {GetterCache} from '../utils/accessor.utils';
import {InfectionInformation} from './models';

export class InfectionEntry implements InfectionEntryViewSetSerializer {
    id?: number;
    created_at: Date | string;
    // @ts-ignore
    infection_information?: InfectionInformation[];
    // @ts-ignore
    location?: number | LocationWithUnitSerializer;
    // @ts-ignore
    patient?: number | Patient;
    start_date?: Date;
    end_date?: Date;

    constructor(ie?: InfectionEntryViewSetSerializer | InfectionEntry) {
        if (ie) {
            if (ie.patient && typeof ie.patient !== 'number') ie.patient = new PatientForVisit(ie.patient as any);
            if (ie.infection_information && ie.infection_information.length) {
                ie.infection_information = (ie.infection_information as (InfectionInformationSerializer | InfectionEntryViewSetInfectionInformationSerializer | InfectionInformation)[])
                    .map(x => new InfectionInformation(x))
                    .sort((a, b) => (comparePeriod(a, b, 'symptom_onset_date', 'resolved')));
            }
            Object.assign(this, ie);

            const pid = getId(this.patient);
            if (pid && ie.infection_information && ie.infection_information.length) CheckPatientCache.add(pid, 'infectionEntries', this.id);
        }
    }

    get hasConfirmedInfection(): boolean {
        return this.infection_information?.some(x => x.isConfirmed);
    }

    @GetterCache()
    get modifiedAt() {
        return this.infection_information?.map(x => x.modified_at || x.created_at).sort((a, b) => new Date(b).getTime() - new Date(a).getTime())[0] || this.created_at;
    }
}
